<template>
  <div>
    <Table border size="large" :columns="tableHeader" :data="chapterData"></Table>
    <div class="page-jump">
      <Page :total="pageTotal" show-elevator :page-size="pageSize" @on-change="pageJump"/>
    </div>
  </div>
</template>

<script>
  import {
    _booksList,_borderImage
  } from "../api/api.js";
  import { alertTips } from "../common/common.js";
  export default {
    name: "TeachingBorderList",
    data(){
      return{
        token: '8c36651aa7a16f5e7bfe95da12c0d485efdbbb908baa7819',
        chapterData: [],
        pageSize: 10,
        page:0,
        pageTotal:0,
        tableHeader: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '科目',
            key: 'subject'
          },
          {
            title: '章节数量',
            key: 'chapter'
          },
          {
            title: '操作',
            key: 'setting',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.jumpBorder(params.index)
                    }
                  }
                }, '查看章节'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style:{
                    marginLeft: '20px'
                  },
                  on: {
                    click: () => {
                      this.getImg(params.index)
                    }
                  }
                }, '生成图片')
              ]);
            }
          }
        ],
      }
    },
    methods: {
      jumpBorder(index){
        this.$router.push({
          name: 'teachingChapterList',
          params: {
            id: this.chapterData[index]['id']
          }
        })
      },
      //教辅列表
      getBooksList: function(){
        const self = this;
        _booksList(this.token,this.page,this.pageSize).then(res=>{
          let data = res.data;
          if (data.code === 0) {
            data.data.content.forEach((current,index,arr)=>{
              current.name = current.name;
              current.subject = current.subject;
              current.chapter = current.chapterCount
            })
            self.chapterData = data.data.content;
            self.pageTotal = data.data.total
          } else {
            alertTips("warning", res.message);
          }
        },res=>{
          console.log(res);
        })
      },
      //翻页
      pageJump(n){
        this.page = n-1;
        this.getBooksList()
      },
      //生成图片
      getImg(index){
        _borderImage(this.chapterData[index]['id']).then(res=>{
          console.log(res);
          if(res.code==0){
            this.$Message.success('生成图片成功');
          }
        })
      }
    },
    created() {
      this.getBooksList()
    }
  }
</script>

<style scoped>
  .page-jump{
    display: flex;
    justify-content: center;
    padding-top: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/components/TeachingBorderList.vue